var _excluded = ["label", "isDisabled", "onClick", "dataTestId", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useListItem } from '@floating-ui/react';
import { cloneElement, isValidElement, useState } from 'react';
import { Box } from '../../../../components/internal';
import { forwardRef } from '../../../../utils';
import { useStyleConfig } from '../../../../utils/use-style-config';
import { useBaseMenuContext } from '../../../BaseMenu/hooks';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * @private For internal use only.
 */
export var _MenuFooter = forwardRef((_ref, ref) => {
  var {
    label,
    isDisabled,
    onClick,
    dataTestId,
    children
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  var [isHovered, setIsHovered] = useState(false);
  var styles = useStyleConfig('_MenuFooter');
  var {
    getItemProps,
    activeIndex
  } = useBaseMenuContext();
  var {
    ref: itemRef,
    index
  } = useListItem();

  var handleClick = () => {
    if (!isDisabled) {
      onClick === null || onClick === void 0 ? void 0 : onClick();
    }
  };

  var itemProps = getItemProps({
    ref: itemRef,
    tabIndex: activeIndex === index ? 0 : -1,
    onClick: handleClick,
    onKeyDown: event => {
      event.preventDefault();

      if (event.key === 'Enter') {
        handleClick();
      }
    }
  });
  var childrenWithProps = /*#__PURE__*/isValidElement(children) && /*#__PURE__*/cloneElement(children, _objectSpread({
    'data-hover': isHovered || undefined,
    isDisabled
  }, itemProps));
  return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
    ref: ref,
    "data-component": "Menu.Footer",
    __css: styles,
    role: "menuitem",
    "data-disabled": isDisabled || undefined
  }, rest), {}, {
    "aria-label": label,
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
    "data-testid": dataTestId !== null && dataTestId !== void 0 ? dataTestId : 'menu-footer-btn',
    children: childrenWithProps
  }));
});
_MenuFooter.displayName = 'Menu.Footer';
//# sourceMappingURL=_MenuFooter.js.map